import React, { LegacyRef } from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';



interface DelayedFlightSearchMenuState {
    startValue: string;
    endValue: string;
    startDate: Date;
    endDate: Date;
}

interface DelayedFlightSearchMenuProps {
    startDate : Date;
    endDate: Date;
    startValue: string;
    endValue: string;
    startDateChangeHandler : (date: Date) => void;
    endDateChangeHandler : (date : Date) =>  void;
}

export default class DelayedFlightSearchMenu extends React.Component<DelayedFlightSearchMenuProps, DelayedFlightSearchMenuState> {

    constructor(props: DelayedFlightSearchMenuProps) {
        super(props);
        let startMomement = moment(this.props.startDate);
        let endMoment = moment(this.props.endDate);
        this.state = {
            startValue: startMomement.format('MM/DD/YYYY h:mm A'),
            endValue: endMoment.format('MM/DD/YYYY h:mm A'),
            startDate: this.props.startDate,
            endDate: this.props.endDate
        }
        

    }

    filterStartDate = (date : Date) : boolean => {
        return true;
    }

    filterEndDate = (date : Date) : boolean => {
        return true;
    }
    
    render() {
        return (
            <div className="row mb-3">              

                    <div className="col-6">
                        <DatePicker className={"db form-control"}
                            onChange={this.props.startDateChangeHandler}
                            selected={this.props.startDate}
                            value={this.props.startValue}
                            withPortal
                            showTimeSelect
                            filterDate={this.filterStartDate}
                            timeFormat="p"
                            timeIntervals={30}
                            placeholderText={"Start Date and Time"}
                            dateFormat="MMMM d, yyyy h:mm aa" />
                    </div>
                    
                    <div className="col-6">
                        <DatePicker className={"db form-control"}
                            onChange={this.props.endDateChangeHandler}
                            selected={this.props.endDate}
                            value={this.props.endValue}
                            withPortal
                            showTimeSelect
                            filterDate={this.filterEndDate}
                            timeFormat="p"
                            timeIntervals={30}
                            placeholderText={"End Date and Time"}
                            dateFormat="MMMM d, yyyy h:mm aa" />
                    </div>
  
            </div>
        );
    }
}

